import { render, staticRenderFns } from "./ta-team.html?vue&type=template&id=6327e7e5&scoped=true&"
import script from "./ta-team.ts?vue&type=script&lang=ts&"
export * from "./ta-team.ts?vue&type=script&lang=ts&"
import style0 from "./ta-team.styl?vue&type=style&index=0&id=6327e7e5&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327e7e5",
  null
  
)

export default component.exports